import { render, staticRenderFns } from "./RelatedDocumentsActions.vue?vue&type=template&id=f9b8bbac&scoped=true"
import script from "./RelatedDocumentsActions.vue?vue&type=script&lang=ts"
export * from "./RelatedDocumentsActions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b8bbac",
  null
  
)

export default component.exports